<template>
  <AppTemplate>
    <template #title>Messages ({{ lines }})</template>
    <div class="card card-body p-2">
        <AsdecodeTable class="mb-4" :columns="columns" url="/api/messages" table="messages" @set-total-records="updateLines"
            @row-click="showLine" @set-selected-rows="getSelection">

            <template #email="slotProps">
                {{ slotProps.data.email }} ({{ slotProps.data.phone }})
            </template>
        </AsdecodeTable>
    </div>
  </AppTemplate>
</template>

<script>
import { defineComponent } from 'vue';
import FormMessage from './FormMessage.vue';
import ShowMessage from './ShowMessage.vue';

export default defineComponent({
    name: 'IndexMessage',

    data() {
        return {
            lines: 0,
            selection: [],
            columns: [
                {
                    key: 'name',
                    label: 'Noms et prenoms',
                    sortable: true,
                    exportable: true,
                },
                {
                    key: 'email',
                    label: 'Client',
                    sortable: true,
                    exportable: true,
                },
                {
                    key: 'recipient',
                    label: 'Email du freelance',
                },
                {
                    key: 'created_at',
                    label: 'Ajouté le',
                    format: 'datetime',
                }
            ]
        }
    },
    methods: {
        showLine(line) {
            this.$dialog.open(ShowMessage, {
                props: {
                    header: 'Message ID'+line.id,
                    style: { width: '50vw' },
                    modal: true,
                },
                data: line
            });
        },
        updateLines(nb) {
            this.lines = nb
        },
        // getSelection(selection) {
        //     this.selection = selection
        // },
        showCreateModal() {
            this.$dialog.open(FormMessage, {
                props: {
                    header: 'Ajouter un message',
                    style: { width: '50vw' },
                    modal: true,
                },

            });
        },
    },
});
</script>